import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {
       updateProductIndexStahltreppe,
       updateStepsStahltreppe,
       updateGelaenderTypeStahlgelaender,
       updateModellStahltreppe,
       updateMusteStahltreppe
      } from '../../../../store/actions/stahltreppen';
import {gelaender} from '../../../../../assets/images/stahltreppen/Gelaender/gelaender';
import {stahltreppe_gelaender} from '../../../../../assets/images/data';
import {InputRadio} from '../../../../module/inputRadio';
import scrollToElement from '../../../../module/scrollToElement';


const Step_1 = (props) => {
   const [muster, updateMuster] = useState('');
   const [isGelaender, updateIsGelander] = useState(false);

   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
      const {index, titel, muster} = props.data.modell[0];
      const {gelaender_index, gelaender_type} = props.data.gelaender[0];
      let stahltreppen_gelaender_type_wrapper = document.querySelectorAll('.stahltreppen_gelaender_type');
      let stahltreppen_gelaender_products = document.querySelectorAll('.stahltreppen_gelaender_products');
      let modal_box_header = document.querySelector('#modal_box_header');

      if (gelaender_type === 'Geländer (einseitig)' || gelaender_type === 'Geländer (beidseitig)') updateIsGelander(true);
      else updateIsGelander(false);

      //update muster description
      updateMuster(muster);

      //scroll to Next Button Container
      if (gelaender_type) scrollToElement();

      //update titel
      if (!muster) modal_box_header.innerHTML = 'Stahltreppe';
      if (titel&&muster==='Sortiment')  modal_box_header.innerHTML = 'Stahltreppe: '+titel;
      if (muster==='Eigenes Muster')  modal_box_header.innerHTML = 'Stahltreppe: Eigenes Muster';

      if (index&&stahltreppen_gelaender_products[index]) {
         for (let i = 0; i < stahltreppen_gelaender_products.length; i++) {
            stahltreppen_gelaender_products[i].classList.remove('check');
         }
         stahltreppen_gelaender_products[index].classList.add('check');
      }

      for (let i = 0; i < stahltreppen_gelaender_type_wrapper.length; i++) {
         stahltreppen_gelaender_type_wrapper[i].classList.remove('check');
      }
      if (stahltreppen_gelaender_type_wrapper[gelaender_index]) {
         stahltreppen_gelaender_type_wrapper[gelaender_index].classList.add('check');
      }

      //update steps
      props.updateSteps(0);

      if (index || muster==='Eigenes Muster' || gelaender_type === 'Kein Geländer' || props.data.allVisitedSteps) {
         props.updateSteps(1);
         props.setUpdateButtonActiveStepToFalse();
      }
      else props.setUpdateButtonActiveStepToTrue();

   }

   const selectGelaenderType = ev => {
      let gelaender_index = ev.currentTarget.getAttribute('index');
      let gelaender_type = ev.currentTarget.getAttribute('titel');
      let image_gelaender = ev.target.currentSrc;

      let gelaenderObject = {
         index: gelaender_index,
         titel: gelaender_type,
         image: image_gelaender
      }
      props.updateGelaenderType(gelaenderObject);
      updateItems();
   }

   const selectStahltreppenGelaender = ev => {
      let modell_index = ev.currentTarget.getAttribute('index');
      let modell_titel = ev.currentTarget.getAttribute('titel');
      let modell_img = ev.target.currentSrc;

      let modellObject = {
         index: modell_index,
         titel: modell_titel,
         img: modell_img,
      }

      props.updateModell(modellObject);
      updateItems();
   }

   const selectMuster = ev => {
      let muster = ev.target.value;
      updateMuster(muster);
      props.updateMuster(muster);
   }


   const arrayRadioItems = [
      {labalValue: 'Sortiment', labelTitel: 'Muster aus unserem Sortiment'},
      {labalValue: 'Eigenes Muster', labelTitel: 'Eigenes Muster hochladen'}
   ]

      return (
           <div className="step_wrapper">
              <div className="step_icon_wrapper">
                  <h2 className="step_header">Soll Ihre Stahltreppe ein Geländer haben?</h2>
                  <div className="inner_form_wrapper inner_wrapper_row">
                           {stahltreppe_gelaender.map((elem, index) => (
                              <div key={index} onClick={selectGelaenderType} className="stahltreppen_gelaender_type" titel={elem.titel} index={index}>
                                 <img className="imgform imgStahltreppenGelaender" src={elem.imgsrc} alt={elem.imgalt} />
                                 <p>{elem.titel}</p>
                              </div>
                           ))}
                  </div>
                  {isGelaender?
                  <>
                  <h2 className="step_header">Welches Muster soll das Geländer haben?</h2>
                  <div className="inner_form_wrapper">
                     <div className="inner_masseMenge_wrapper">
                        <div className="textfield-wrapper">
                           <InputRadio
                              arial_label='Muster'
                              name='Muster'
                              value={muster}
                              onChange={selectMuster}
                              arrayRadioItems={arrayRadioItems}
                           />
                        </div>
                     </div>
                     {muster === 'Sortiment'?
                     <div className="inner_form_wrapper gelaender_wrapper">
                        {gelaender.map((elem, index) => (
                           <div key={index} onClick={selectStahltreppenGelaender} className="formWrapper stahltreppen_gelaender_products" titel={elem.titel} index={index}>
                              <img className="imgform imgStahltreppenGelaender" src={elem.product_img} alt={elem.product_img} />
                              <p>{elem.titel}</p>
                           </div>
                        ))}
                     </div>
                     :''
                     }
                     {muster === 'Eigenes Muster'?<p>Im lezten Schritt haben Sie die Möglichkeit ein eigenes Muster hochzuladen.</p>:''}
                  </div>
                  </>
                  :''}
              </div>
          </div>
       )
}

const mapStateToProps = state => {
    return {
       data: state.stahltreppenReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateProductIndex: ev => dispatch(updateProductIndexStahltreppe(ev)),
      updateSteps: ev => dispatch(updateStepsStahltreppe(ev)),
      updateGelaenderType: ev => dispatch(updateGelaenderTypeStahlgelaender(ev)),
      updateModell: ev => dispatch(updateModellStahltreppe(ev)),
      updateMuster: ev => dispatch(updateMusteStahltreppe(ev))
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_1);
